import React, {useEffect, useState} from 'react'
import '../../Work-css/Guiding_councsling.css';
import Option from '../Guiding_Councling/Option';
import Form from '../Guiding_Councling/Form';
import Mpesa from '../Guiding_Councling/Mpesa';

function Guiding_and_counsling({rock}) {
    const [options, setOptions] = useState(true)
    const [mpesa, setMpesa] = useState(false)
    const [form, setForm] = useState(false)
  return (
    <div className='Guiding_DIV'>
        {options==true?(<div className='OPT'><Option options={setOptions} mpesa={setMpesa} form={setForm} rock={rock} /></div>):('')}
        {mpesa==true?(<div className='OPT'><Mpesa options={setOptions} mpesa={setMpesa} form={setForm} rock={rock} /></div>):('')}
        {form==true?( <div className='OPT'><Form options={setOptions} mpesa={setMpesa} form={setForm} rock={rock} /></div>):('')}
       
      
    </div>
  )
}

export default Guiding_and_counsling